import styles from './FeatureContents.module.css';

/**
 * @component CommunicationContent
 * @description 소통 카드 내용
 */
function CommunicationContent() {
  const messages = [
    { id: 1, sender: '김감독', message: '공고 결과 안내드립니다.', unread: 3, online: true },
    { id: 2, sender: '박PD', message: '촬영 일정 확인 부탁드립니다.', unread: 0, online: false },
  ];

  return (
    <div className={styles.communicationContent}>
      {messages.map((msg) => (
        <div key={msg.id} className={styles.messageItem}>
          <div className={styles.messageHeader}>
            <div className={styles.senderRow}>
              {msg.online && <span className={styles.onlineDot} />}
              <span className={styles.messageSender}>{msg.sender}</span>
            </div>
          </div>
          <div className={styles.messageBody}>
            <span className={styles.messageText}>{msg.message}</span>
            {msg.unread > 0 && (
              <span className={styles.unreadBadge}>{msg.unread}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default CommunicationContent;
